<template>
    <div class="headCon" :class="{'small':isTop}">
    <div class="first">
     <span> {{$t('a')}}</span>
      <div class="rightIcon">
        <a href="mailto:name@email.com"> <i class="iconfont icon-youxiang" style="font-size: 25px;"></i></a>
        <i class="iconfont icon-sousuo i" @click="searchShow=true"></i>
        <div class="search searchT" @click="changeLanguage('en')" v-if="$i18n.locale==='zh-CN'">
         EN
        </div>
        <div class="search searchT" @click="changeLanguage('zh-CN')" v-else>
          CN
        </div>
      </div>
    </div>
      <div class="nav">
        <ul>
          <li v-for="(item,index) in $t('navList')" :key="index" @click="goto(index)">
              <span style="margin-left: -10px;" >{{item}}</span>
              <img :src="src">
              <span class="line" ></span>
            <div class="products animated fadeIn" v-if="index===1">
              <a  v-for="(i,ind) in proList" :key="ind" style="text-transform: capitalize;text-align: left;font-family: light2" @click="gotoPro(i.ID,ind)">·&nbsp;{{i.CALLED}}</a>
            </div>
          </li>
        </ul>
      </div>
        <img class="bt animated  bounceInDown" src="../assets/bt.png" alt="" @click="goto(0)">
      <transition name="el-fade-in-linear">
        <div class="sea" v-show="searchShow">
          <div style="position: absolute;height:100%;width:100%;z-index: -1;top:0;left: 0;background-color: rgba(0,0,0,.9);" @click="searchShow=false;input=''">

          </div>
          <input style="z-index: 1;" type="text" v-model="input" placeholder="请输入要搜索的关键字" @click="searchShow=true">
        </div>
      </transition>
      
      
<!--      移动端导航栏-->
      <div class="top animated fadeInUp">
        <img class="mImg" src="../assets/bt.png" alt="" @click="goto(0)">
        <div class="mNav" :class="{active: menuOpen}" @click="menuOpen=!menuOpen">
          <span class="burger"></span>
          <span class="burger"></span>
          <span class="burger"></span>
        </div>
      </div>
      <div class="menuBox" :class="{open: menuOpen}">
        <div class="item">
         <span v-for="(item,index) in $t('navList')" :key="index" @click="goto(index)">{{item}}</span>
        </div>
        <div class="search searchT men" @click="changeLanguage('en')" v-if="$i18n.locale==='zh-CN'">
          EN
        </div>
        <div class="search searchT men" @click="changeLanguage('zh-CN')" v-else>
          CN
        </div>
      </div>
    </div>
</template>

<script>
  import { setup } from "../local/index";
  import Scrollbar from 'smooth-scrollbar';
  import {getProductstypeUrl2} from '../util/lang'

    export default {
        name: "first",
      data(){
          return{
            menuOpen:false,
            isShowLeft:false,
            isTop:false,
            input:'',
            searchShow:false,
            colorStyle:{color:'#C9382C'},
            widthStyle:{width:'100%',display:'inline-block'},
            scrollbar: '',
            num:0,
            scrollTop: 0,
            proList:[],
            isShowEn:false,
            src:require('../assets/right.png'),
            select:'',
            navList:[
              "Home",
              "Product",
              "About Us",
              "News",
              "Support",
              "Feedback"
            ]
          }
      },
      watch: {
        $route: 'getScrollbar'
      },
      mounted() {
        this.getScrollbar()
        this.num=parseInt(localStorage.getItem('index'))
        if(this.$i18n.locale==='en'){
          this.getPro('23')
        }else{
          this.getPro('36')
        }
      },
      methods:{
        gotoPro(id,index){
          this.$router.push({path:'/product',query:{id:id,select:index}})
        },
        getPro(id){
          this.$nextTick(()=>{
            const url = `${getProductstypeUrl2( this.$i18n.locale,id)}`
            this.$axios.get(url).then(res => {
              this.proList=res.data
            })
          })
        },
        getScrollbar(){
          this.$nextTick(()=>{
            this.scrollbar=Scrollbar.get(document.getElementById('scroller-wrapper'))
            this.isTop=false
            if(this.scrollbar){
              this.scrollbar.addListener((status) => {
                if(status.offset.y>0){
               this.isTop=true
                }else{
                  this.isTop=false
                }
                this.scrollTop=status.offset.y
              });
            }
          })
        },
          goto(n){
          this.menuOpen=false
            if(n===0){
              this.$router.push({path:'/'})
            }else if(n===1){
              this.$router.push({path:'/product'})
            }else if(n===2){
              this.$router.push({path:'/about'})
            }else if(n===3){
              this.$router.push({path:'/news'})
            }else if(n===4){
              this.$router.push({path:'/contact'})
            }else {
              this.$router.push({path:'/feed'})
            }
          },
        changeLanguage(lang) {
          this.menuOpen=false
          if(lang==='en'){
            this.isShowEn=false
          }else{
            this.isShowEn=true
          }
          this.$i18n.locale = lang
          window.localStorage.setItem('language', lang)
          setup(lang);
          this.$router.go(0)
          // location.reload() // 为了重新实例化vue-router对象，避免一些bug
        }
      }
    }
</script>

<style scoped>
  .sea{
    position: fixed;
    left: 0;
    height:100vh;
    width:100%;
    top:0;
    text-align: center;
    z-index: 10000;
    background-color: black;
  }
  .sea input
  {
    width:300px;
    height:20px;
    padding-top: 10px;
    padding-bottom: 5px;
    border-radius: 20px;
    border: none;
    padding-left: 10px;
    margin-top: 45vh;
    line-height: 40px;
  }
  .sea input:focus{
    outline: none;
  }
.headCon{
  width:100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  color: black;
  transition: .4s;
  background-color: white;
}
.first{
  width:85%;
  margin-left: 15%;
  display: flex;
  flex-direction: row;
  position: relative;
  padding-top: 30px;
  transition: all 1s;
}
.first span{
  padding-right:160px;
  display: inline-block;
  padding-bottom: 20px;
 border-bottom: 2px solid rgba(0, 0, 0, 0.1);
}
  .rightIcon{
    width:30%;
    display: flex;
    flex-direction: row;
    position: absolute;
    right:0;
  }

  .rightIcon .i{
    width:44px;
    height:44px;
    cursor: pointer;
    border: 1px solid #DBDBDB;
    border-radius: 50%;
    margin-left: 5%;
    line-height: 40px;
    color:#686868;
    transition: all 2s;
  }
  .rightIcon a{
    width:44px;
    height:44px;
    cursor: pointer;
    border: 1px solid #DBDBDB;
    border-radius: 50%;
    margin-left: 5%;
    line-height: 40px;
    color:#686868;
    transition: all 2s;
    text-decoration: none;
    display: inline-block;
  }
  .rightIcon a:hover{
    background-color: #C9382C;
    color:white;
  }
  .rightIcon .i:hover{
    background-color: #C9382C;
    color:white;
  }
  .search{
    height:44px;
    width:44px;
    background-color: red;
    border-radius: 50%;
    margin-left: 5%;
    text-align: center;
    line-height: 44px;
    cursor: pointer;
  }
  .searchT{
   background-color: white;
    color:#777777;
    border: 1px solid #D1D1D1;
    transition: all 2s;
  }
  .searchT:hover{
    background-color: #C9382C;
    color:white;
  }
  .nav {
    width: 85%;
    margin-left: 15%;
    padding-top: 10px;
    margin-top:10px;
  }
  .nav ul{
    width:100%;
    list-style: none;
    padding-inline-start: 0;
  }
  .nav ul li{
    float: left;
    color:black;
    font-weight: bold;
    margin-left: 10.5%;
    cursor: pointer;
    position: relative;
    height:50px;
    width:6%;
  }
  .nav ul li span{
    transition:color 2s;
    -webkit-transition:color 2s ;
  }
  .nav ul li:first-child{
    margin-left: 0;
    text-align: center;
    display: block;
  }
  .nav ul li img{
    width:16px;
    height:16px;
    margin-top: 2px;
    position: absolute;
  }
  .line{
    position: absolute;
    bottom: 0;
    width:0;
    height:2px;
    background-color:#C9382C;
    left: 50%;
    display: none;
    animation: myMove .5s linear forwards;
    transform: translate(-50%);
  }
@keyframes myMove {
  from {width:0;}
  to {width:100%;}
}
@-webkit-keyframes mymove /*Safari 和 Chrome*/{
  from {width:0;}
  to {width:100%;}
}
  .bt{
    position: absolute;
    top:10px;
    left: 50.5%;
    width:100px;
    transition: all 1s;
    cursor: pointer;
  }
  .nav ul li:hover .line,.nav ul li:hover{
    display: block;
   color:#C9382C;
  }
  .nav ul li:hover img{
    transform:rotate(90deg);
    -ms-transform:rotate(90deg); /* Internet Explorer */
    -moz-transform:rotate(90deg); /* Firefox */
    -webkit-transform:rotate(90deg); /* Safari 和 Chrome */
    -o-transform:rotate(90deg); /* Opera */
    -webkit-transition:-webkit-transform 1s linear;
    transition:transform 1s linear;
  }
.products{
  position: absolute;
  top:100%;
  background-color: white;
  flex-direction: column;
  display: none;
  z-index: 9999;
  padding: 10px 0;
  width:200%;
}
.products a{
  font-size: 14px;
  transition:color 1s;
  -webkit-transition:color 1s ;
  font-weight: bold;
  padding: 10px 0;
  color:black;
}
.products a:hover{
  color:#C9382C;
}
.products::before{
  width: 10000px;
  position: absolute;
  top:0;
  height: 100%;
  background:white;
  content: '';
  visibility: visible;
  opacity: 1;
  transition: all .5s;
  left:100%;
  z-index: 9999;
}
.products::after{
  width:10000px;
  position: absolute;
  top: 0;
  height: 100%;
  background: white;
  content: '';
  visibility: hidden;
  opacity: 1;
  transition: all .5s;
  right:100%;
  z-index: 9999;
}
.nav ul li:hover .products, li:hover .products::after{
  display: flex;
  visibility: visible;
}


.small .first{
margin-top: -80px;
}
.small .bt{
  width:60px;
  left: 52%;
  top:1px;
  transition: all 1s;
}
.top{
  display: none;
}
  .menuBox{
    position: fixed;
    top: 0;
    left: 100%;
    width: 300px;
    height: 100vh;
    background: #f2f2f2;
    z-index: 1010;
    overflow-y: auto;
    transition: .8s;
  }
  .menuBox.open{
    transform: translateX(-300px);
  }
  .menuBox .item span{
    display: block;
    font-size: 18px;
    color:#C9382C;
    width:100%;
    padding: 18px 0px;
    border-bottom: 1px solid #ccc;
  }
@media screen and (max-width: 1440px){
.bt{
  left:50%;
  width:90px;
}
  .small .bt{
    left: 51%;
  }
}
  @media screen and (max-width: 1280px){
  .nav ul li{
    width:7%;
  }
  }
  @media screen and (max-width:450px){
    .first,.nav,.bt{
      display: none;
    }
    .top{
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      width:100%;
      padding: 20px 0px;
    }
    .mImg{
      height:50px;
      object-fit: cover;
      margin-left: 60px;
    }
    .mNav{
      display: block;
      transition: .8s;
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;
      width: 60px;
      background-color:#C9382C;
    }
    .mNav .burger{
      width: 32px;
      height: 4px;
      background-color: #fff;
      position: absolute;
      top: 28px;
      left: 50%;
      margin: 0px 0px 0px -16px;
      transform-origin: center;
      transition: .8s;
    }
    .mNav .burger:nth-of-type(2){
      top: 38px;
    }
    .mNav .burger:nth-of-type(3){
      top: 48px;
    }
    .mNav.active{
      transform: translateX(-300px);
      background-color: #C9382C;
    }
    .mNav.active .burger:nth-of-type(1){
      top: 40px;
      transform: rotate(225deg);
    }
    .mNav.active .burger:nth-of-type(2){
      left: -100%;
      opacity: 0;
    }
    .mNav.active .burger:nth-of-type(3){
      top: 40px;
      transform: rotate(-225deg);
    }
    .men{
      margin-top: 10px;
      margin-left: 43%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/first.vue